import React, { useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { useBlogContext, useBlogFilterContext } from '../helpers';
import PostByTagStyles from './PostsByTag.module.scss';

const PostsByTag = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation('resources');
  const {
    postsByTag: { title, showLabel, hideLabel },
    blogPath,
  } = t('blog', {
    returnObjects: true,
  }) as any;
  const {
    filters: { tags } = { tags: [] },
    appliedFilters,
    addFilterTo,
  } = useBlogFilterContext() || {};
  const { tagsCountNumber } = useBlogContext() || { tagsCountNumber: {} };
  const { language } = i18n;
  const [showAll, setShowAll] = useState(false);

  const handleShowResults = (value: string) => {
    addFilterTo?.('tags', value);
    router.push(`${language !== 'en-GB' ? '/fr-FR' : ''}${blogPath}`);
  };

  // Only show PostByTags when no filters are selected
  if ((appliedFilters ?? []).length !== 0) return;

  return (
    <div className={PostByTagStyles.postByTagWrapper}>
      <div
        className={classNames({
          [PostByTagStyles['postByTagWrapper_collapsed']]: tags.length > 5 && !showAll,
        })}
      >
        <div className={PostByTagStyles.headerWrapper}>
          <h3>{title}</h3>
        </div>
        <div className={PostByTagStyles.tagsWrapper}>
          {tags.map((item) => {
            return (
              !!item.name && (
                <div className={PostByTagStyles.tag} key={item.key}>
                  <button
                    className={PostByTagStyles.tagButton}
                    onClick={() => handleShowResults(item.key)}
                    aria-label={`${item.name} (${tagsCountNumber?.[item.id]})`}
                  >
                    {`${item.name} (${tagsCountNumber?.[item.id]})`}
                  </button>
                </div>
              )
            );
          })}
        </div>
      </div>
      {tags.length > 5 ? (
        <div className={PostByTagStyles.controls}>
          <button
            className={PostByTagStyles.showAll}
            onClick={() => setShowAll((state) => !state)}
            aria-label={showAll ? hideLabel : showLabel}
          >
            {showAll ? hideLabel : showLabel}
          </button>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostsByTag;
